<template>
  <myhead @next="next" @lookmore="more">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="mb50 pad14 h100vh" ref="textarearef">
    <input type="" v-model="title" name="" placeholder="请输入标题">
    <hr class="opacity5 mt15 mb20" />
    <textarea name="" id="" cols="30" v-model="content" rows="10" class="size14 width100" @input="inputop" placeholder="请填写内容"></textarea>
  </div>
  <div class="pad15 fixed l r b gray">
    <van-button type="primary" round block @click="zf">￥{{total_amount}} 支付审核费用</van-button>
  </div>
  <!-- <van-popup
    v-model:show="playAlery"
    position="bottom"
    :closeable="true"
    class="center vh30 pad25 size16 b500"
  >
    <div>审核费用</div>
    <div class="Cred size24 pad20"> <span class="size12">￥</span>{{total_amount}}</div>
    <van-radio-group class="payBox" v-model="typeid">
        <van-radio name="2" label-position="left"><img src="@/assets/img/pay-wx.png" alt="">
          <span class="inlnie" style="">微信支付</span>
        </van-radio>
        <van-radio name="1" label-position="left"><img src="@/assets/img/pay-aliay.png" alt=""><span class="inlnie">支付宝支付</span></van-radio>
      </van-radio-group>
      <van-button block round type="primary" class="mt90" @click="next">提交</van-button>
  </van-popup> -->
  <PayDialog v-model:showPopup="playAlery" title="审核费用" :amount="total_amount" :nextFn="zf" v-if="isSHowPay"></PayDialog>
</template>

<script>
import PayDialog from "@/components/PayDialog.vue";
export default {
  name: 'Home', components: { PayDialog },
  data () {
    return {
      playAlery: false,
      total_amount: 0,
      title: '', content: '',
      isSHowPay: true
    }
  },
  watch: {
  },
  methods: {
    more () {
      console.log("更多")
    },
    next () {
      history.forward()
    },
    zf (amount, typeid) {
      if (this.playAlery) {
        this.$store.state.forumKey++;
        this.ajax({
          method: "post", url: "pay/pay", data: {
            typeid,
            no: this.no,
            return_url: location.origin + "/#/forum"
          }, myData: { showMsg: false }
        }).catch(({ message }) => {
          if (amount == 0) {
            return this.$router.replace({ path: '/forum' })
          } else {
            this.showNotify({ message })
          }
        }).then(({ data }) => {
          if (typeid == 1) {
            location.href = data.info;
          } else {
            //开发中
          }
        })
      } else {
        this.ajax.post("forum/onlineforumadd", { title: this.title, content: this.content }).then(({ data }) => {
          this.playAlery = true;
          this.no = data.no;
        })
      }
    },
    inputop () {
      document.getElementById('containerScroll').scrollTop = 0
    }
  },
  computed: {},
  created () {

    document.getElementById('containerScroll').scrollTop = 0

    this.ajax.post("forum/getonlineforum").then(({ data }) => {
      this.total_amount = data.total_amount
    })
    window.addEventListener('resize', function () {
      document.getElementById('containerScroll').scrollTop = 0
      document.activeElement.scrollIntoViewIfNeeded();
    });
  }
}
</script>

<style scoped>
.h100vh {
  height: calc( 100vh - 44px )
}
</style>
